export interface SuccessPopupData {
  body: string
  // Can add more fields here if needed
}

export enum SetupTaskId {
  GettingStarted = 'GettingStarted',
  BookingSystemAdvanced = 'BookingSystemAdvanced',
  PaymentsAndDesposits = 'PaymentsAndDesposits',
  MarketingTools = 'MarketingTools',
  GMBOnboarding = 'GMBOnboarding',
}

export interface SetupTask {
  taskId: SetupTaskId
  title: string
  duration: number
  relatedGuidesPath?: 'Website' | 'Booking System' | 'Payments' | 'Marketing Tools'
  dependsOnTasks: SetupTaskId[]
  successPopupData?: SuccessPopupData
  callOutCard?: {
    title: string
    body: string
    actions: {
      title: string
      route?: {
        screen: string
        params?: Record<string, any>
      }
    }[]
  }
}

const setupTasksData = [
  {
    taskId: SetupTaskId.GettingStarted,
    title: 'Getting started on Solo',
    duration: 20,
    successPopupData: {
      body: '**Great you\'ve set up the core of your booking system!**',
    },
    dependsOnTasks: [],
  },
  {
    taskId: SetupTaskId.BookingSystemAdvanced,
    title: 'Customise your booking system',
    duration: 20,
    relatedGuidesPath: 'Booking System',
    successPopupData: {
      body: '**Nice, you are making the most of the Solo booking system!**',
    },
    dependsOnTasks: [SetupTaskId.GettingStarted],
  },
  {
    taskId: SetupTaskId.PaymentsAndDesposits,
    title: 'Choose how and when you get paid',
    duration: 20,
    relatedGuidesPath: 'Payments',
    successPopupData: {
      body: '**Great, you are now fully set up to accept payments!**',
    },
    dependsOnTasks: [SetupTaskId.GettingStarted],
  },
  {
    taskId: SetupTaskId.GMBOnboarding,
    title: 'Get new clients on Google',
    duration: 20,
    successPopupData: {
      body: '**Great, you\'re set up to grow your online presence!**',
    },
    dependsOnTasks: [SetupTaskId.GettingStarted],
  },
  {
    taskId: SetupTaskId.MarketingTools,
    title: 'Reward and retain your clients',
    duration: 20,
    relatedGuidesPath: 'Marketing Tools',
    successPopupData: {
      body: '**Great, you\'re set up to grow your customer base!**',
    },
    dependsOnTasks: [SetupTaskId.GettingStarted],
  },
]

export type SetupTaskData = (typeof setupTasksData)[number]

export default setupTasksData
